import { http } from "../http/Http";
import { AuditLogAction } from "../models/AuditLogAction";
import { ServiceResponse } from "../models/ServiceResponse";

export class AuditLogActionService {

    getAuditLogActions = async (): Promise<ServiceResponse<AuditLogAction[]>> => {
        const { data } = await http.get<ServiceResponse<AuditLogAction[]>>("AuditLogAction/GetAll");
        return data;
    };

}